<div class="wrapper">
  <div class="search-filter-section flex items-center gap-[16px] mt-[24px] mb-[20px]">
    <div class="filter-dropdown-container" [class.filter-active]="activeFilter !== 'all'">
      <button
        class="filter-button flex items-center gap-[8px]"
        [matMenuTriggerFor]="filterMenu"
        >
        <span>{{ filterLabel }}</span>
        <mat-icon svgIcon="chevron-down" class="chevron-icon"></mat-icon>
      </button>
      <mat-menu #filterMenu="matMenu" class="filter-menu-panel" xPosition="after">
        <button mat-menu-item (click)="setFilter('all')" [class.selected-filter]="activeFilter === 'all'">
          All
        </button>
        <button mat-menu-item (click)="setFilter('enabled')" [class.selected-filter]="activeFilter === 'enabled'">
          Enabled
        </button>
        <button mat-menu-item (click)="setFilter('disabled')" [class.selected-filter]="activeFilter === 'disabled'">
          Not enabled
        </button>
      </mat-menu>
    </div>
    <div class="flex-1">
      <app-search (handleSearch)="onSearch($event)" [placeholder]="'Search bid items...'" />
    </div>
  </div>

  <div class="counter-section flex justify-end items-center mb-[12px]">
    <span class="text-type-14 text-[#8b94b3]">{{ totalEnabled }} of {{ totalRecords }} enabled</span>
  </div>

  @if (loading) {
    <div class="loading-bar text-type-14 text-[#1036D6] mb-[8px]">Updating bid items...</div>
  }

  @if (filteredBidItems?.length) {
    <div class="bid-items-table">
      <table [dataSource]="filteredBidItems" class="mat-elevation-z8 table" mat-table>
        <ng-container matColumnDef="checkbox">
          <th *matHeaderCellDef mat-header-cell class="checkbox-col">
            <mat-checkbox
              color="primary"
              [checked]="selectAllChecked"
              [indeterminate]="selectAllIndeterminate"
              (change)="toggleSelectAll()"
              [disabled]="loading"
              matTooltip="Select all"
              />
          </th>
          <td *matCellDef="let row" mat-cell class="checkbox-col">
            <mat-checkbox color="primary" [checked]="row.track_material_quantity" (change)="toggleBidItem(row)" (click)="$event.stopPropagation()" />
          </td>
        </ng-container>
        <ng-container matColumnDef="item">
          <th *matHeaderCellDef mat-header-cell>Item</th>
          <td *matCellDef="let row" mat-cell><div class="text-type-11">{{ row.item }}</div></td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th *matHeaderCellDef mat-header-cell>Description</th>
          <td *matCellDef="let row" mat-cell><div class="text-type-11">{{ row.description }}</div></td>
        </ng-container>
        <ng-container matColumnDef="uom">
          <th *matHeaderCellDef mat-header-cell>UOM</th>
          <td *matCellDef="let row" mat-cell><div class="text-type-11">{{ row.uom }}</div></td>
        </ng-container>
        <ng-container matColumnDef="materials">
          <th *matHeaderCellDef mat-header-cell>Materials</th>
          <td *matCellDef="let row" mat-cell>
            @if (row.track_material_quantity && row.materials?.length) {
              <div (click)="openMaterialsDialog(row, $event)" class="material-badge material-badge-active cursor-pointer">
                {{ row.materials.length }} {{ row.materials.length === 1 ? 'material' : 'materials' }}
              </div>
            }
            @if (row.track_material_quantity && !row.materials?.length) {
              <div (click)="openMaterialsDialog(row, $event)" class="material-badge material-badge-empty cursor-pointer">+ Add</div>
            }
            @if (!row.track_material_quantity) {
              <span class="text-type-14 text-[#ccc]">—</span>
            }
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>
  }

  @if (!filteredBidItems?.length && !loading) {
    <div class="no-data text-type-8 mt-[80px]">No bid items found.</div>
  }

  @if (totalFilteredRecords > pagination.pageSize) {
    <app-paginator (pageChanged)="onPageChanged($event)" [itemsPerPage]="pagination.pageSize" [maxVisiblePages]="5" [totalItems]="totalFilteredRecords" class="paginator" />
  }
</div>
